export const PUSH_UPDATE_CONTRACTOR_DEBT_STATES_UPDATED = 'PUSH_UPDATE_CONTRACTOR_DEBT_STATES_UPDATED'
